import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { DispatcherDTO } from 'shared/modules/dispatcher/DispatcherDTO';

export function shouldShowUserChangePassword(
  date?: string,
  password_changed_at?: string | null,
) {
  if (!date) return false;
  const created_date = DateTime.fromISO(date);
  //Check if user created before May 8th 2023
  const before = DateTime.fromISO('2023-05-08');
  return created_date < before && !password_changed_at;
}

export function useDispatcherPasswordEnhancement(data?: DispatcherDTO) {
  const createdAt: string = data?.created_at || '';
  const passwordChangedAt: string = data?.p_changed_at || '';
  const shouldShowPasswordReminder = useMemo(() => {
    if (createdAt !== '') {
      return shouldShowUserChangePassword(createdAt, passwordChangedAt);
    }
    return false;
  }, [createdAt, passwordChangedAt]);

  return shouldShowPasswordReminder;
}
